import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { OFText } from "design_system/components/OFText";

import PriceSwitch from "../PriceSwitch";

type Props = {
  item: any;
  onTogglePriceClick: (item: any) => void;
};

export const PriceSwitchRow = ({ onTogglePriceClick, item }: Props) => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="center" justifyContent="space-between" mb="16px">
      <OFText textStyle="body3">{t(`checkout:toggle-subscription-label`)}</OFText>
      <PriceSwitch {...item} onToggle={() => onTogglePriceClick(item)} />
    </Flex>
  );
};
